// const BASE_URL = '/localhost:8000';
// const API = {
//   auth: `$/auth/`,
//   quiz: `/eventOldQuiz/quiz/`,
//   answer: `/eventOldQuiz/answer/`,
//   point: `/eventOldQuiz/point/`,
// };
// export default API;

const BASE_URL = "http://event.sinor.co.kr:8000";
const API = {
  auth: `/auth/`,
  quiz: `/eventOldQuiz/quiz/`,
  answer: `/eventOldQuiz/answer/`,
  point: `/eventOldQuiz/point/`,
};
export default API;

// const BASE_URL = 'http://127.0.0.1:8000';
// const API = {
//   auth: `${BASE_URL}/auth/`,
//   quiz: `${BASE_URL}/eventOldQuiz/quiz/`,
//   answer: `${BASE_URL}/eventOldQuiz/answer/`,
//   point: `${BASE_URL}/eventOldQuiz/point/`,
// };
// export default API;
